export function getUrlWithQueryParams({
    additionalParams = {},
    withCurrentParams = true,
}: {
    additionalParams?: Record<string, number>;
    withCurrentParams?: boolean;
} = {}): string {
    const params = new URLSearchParams(withCurrentParams ? window.location.search : '');

    for (const key of Object.keys(additionalParams)) {
        params.set(key, String(additionalParams[key]));
    }

    let url = window.location.origin + window.location.pathname;

    if (params.size) {
        url = `${url}?${params.toString()}`;
    }

    return url;
}
